import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TreeViewModule } from '@core/components/fc-tree-view/fc-tree-view.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { FuseProgressBarModule } from '@fuse/components';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgxMaskModule } from 'ngx-mask';
import { CreateRecurrenceLinkLogsService } from './services/create-recurrence-link-logs.service';
import { CreateRecurrenceLogsService } from './services/create-recurrence-logs.service';
import { UpdatedByLogService } from './services/updated-by-log.service';
import { TabHistoricComponent } from './tab-historic.component';

@NgModule({
  declarations: [
    TabHistoricComponent
  ],
  imports: [
    TranslateModule,

    FuseSharedModule,
    FuseProgressBarModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatIconModule,
    NgxMaskModule.forRoot(),

    LocationsComponentModule,
    MaintenanceTypeModule,
    DateTimePickerModule,
    SegmentsModule,
    CompaniesComponentModule,
    TreeViewModule,
    PipesModule
  ],
  exports: [
    TabHistoricComponent
  ],
  providers: [
    CreateRecurrenceLogsService,
    CreateRecurrenceLinkLogsService,
    UpdatedByLogService
  ]
})
export class TabHistoricModule { }
